import Vue from 'vue'
import { isNemoApp } from './index'

function setRem () {
  const html = document.documentElement
  const isNemoAppFlag = isNemoApp()
  Vue.prototype.isNemoApp = isNemoAppFlag
  if (isNemoAppFlag) {
    const baseSize = 32
    const designWith = 750
    const scale = html.clientWidth / designWith
    html.style.fontSize = Math.max(baseSize / 2, Math.min(baseSize * scale, baseSize)) + 'px'
  }
}

setRem()
